module.exports = __webpack_public_path__ + "Roboto-ThinItalic.1e5737be5c68c15c3a10.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@c4/assets/src/assets/fonts/roboto/Roboto-ThinItalic.ttf
// module id = 390
// module chunks = 2